const mutations = {
  SET_ASSIGNMENTS(state, { assignments }) {
    state.assignments = assignments
  },
  SET_STATUS_COUNTERS(state, payload) {
    state.statusCounters = {
      ...state.statusCounters,
      ...payload
    }
  },
  SET_COUNT_PENDING(state, payload) {
    state.countPending = payload
  }
}

export default mutations
